import { Box, Flex, Text, useTheme, Icon } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { BsStarFill } from 'components/Icons/Icons';
import { FC } from 'react';
import { rgba } from 'polished';
import { Link } from 'react-router-dom';
import { Button } from 'components';

const NoDefaultBannerSmall: FC = () => {
  const { t } = useTranslation('projects');

  const { colors } = useTheme();

  return (
    <Box pos="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" w="100%" p="24px" bg="transparent">
      <Box bg={rgba(colors.error.primary, 0.08)} borderRadius="base" p="36px" pos="relative">
        <Flex
          bg="secondary.300"
          w="30px"
          h="30px"
          borderRadius="round"
          justify="center"
          align="center"
          mr="12px"
          pos="absolute"
          top="0"
          left="50%"
          transform="translate(-50%, -50%)"
        >
          <Icon as={BsStarFill} color="white" />
        </Flex>
        <Box maxW="262px" margin="0 auto" textAlign="center">
          <Text as="h2" textStyle="h4" mb="20px">
            {t('warning.alternateTitle')}
          </Text>
          <Text textStyle="p" lineHeight="1.6" mb="24px">
            {t('warning.alternateDescription')}
          </Text>
          <Link to="/projects">
            <Button>
              <Text as="span">{t('warning.buttonLabel')}</Text>
            </Button>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default NoDefaultBannerSmall;
